import { z } from 'zod';
/**
 * Recorded in docs/adr/0014-user-and-membership-status-enums.md.
 * `REVOKED` rather than a soft-delete flag: docs/004 rule 7 is hard-delete by default,
 * but a revoked membership is an auditable fact, not deleted history.
 */
export const MEMBERSHIP_STATUSES = ['INVITED', 'ACTIVE', 'REVOKED'];
export const membershipStatusSchema = z.enum(MEMBERSHIP_STATUSES);
/**
 * The join between a global `User` and a `Tenant`. Tenant-scoped, so every query for it
 * must carry a `tenantId` — enforced by the Prisma tenant guard in packages/db, not by
 * remembering to write the filter.
 *
 * The DTO embeds the user's display fields rather than the whole `UserDTO`: this is a
 * membership list, and widening it to a full user record is how a cross-tenant leak of
 * global identity data starts.
 */
export const membershipDTOSchema = z.object({
    id: z.string().min(1),
    userId: z.string().min(1),
    email: z.string().email(),
    name: z.string().min(1),
    status: membershipStatusSchema,
    invitedAt: z.string().datetime(),
    acceptedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=membership.js.map